export const ADD_CONTACTS = 'ADD_CONTACTS'
export const ADD_CONTACT = 'ADD_CONTACT'
export const SET_AVATAR = 'SET_AVATAR'


